import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error, info) { console.error("UI-Fehler:", error, info); }
  reset = () => { this.setState({ hasError: false }); };
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-8 text-center">
          <div className="text-lg font-semibold">Es ist ein Fehler aufgetreten</div>
          <p className="max-w-md text-sm text-muted-foreground">Diese Ansicht konnte nicht geladen werden. Der Rest der Anwendung funktioniert weiter.</p>
          <div className="flex gap-2">
            <button className="rounded-md border border-border px-4 py-2 text-sm hover:bg-accent" onClick={this.reset} data-testid="error-retry">Erneut versuchen</button>
            <button className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground" onClick={() => { window.location.href = "/"; }} data-testid="error-home">Zur Startseite</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
